import { WithChildrenProps } from '@app/types/generalTypes';
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PageTitle: React.FC<WithChildrenProps> = () => {
  return (
    <Helmet>
      <title>{process.env.REACT_APP_PAGE_TITLE_NAME}</title>
    </Helmet>
  );
};
